<!--suppress ALL -->
<template>
  <div>
    <!--资源管理左侧菜单-->
    <div id="zy_menu_left" class="col_2_1 w180 zy_menu_left" style="height:100%; overflow:hidden;">
      <span><a @click="editClassification('f', null, '', '0', '0')"  class="add2"></a></span>
      <dl class="main_menu" v-for="item in RCTree" :key="item.id">
            <span>
              <dt class="total-scope">
                <a href="javascript:;" @click="searchByClassification(item.id)" class="single_ellipsis total-scope-name" :title="item.name" style="width: 155px" >{{item.name}}</a>
                <a href="javascript:void(0);" @click="editClassification('s', null, '', item.id, '0')" class="addSub" title="添加子类"></a>
                <i class="edit"  title="编辑" @click="editClassification('f', item.name, item.id, item.parentId, item.parentIds)"></i>
                <a href="javascript:;" title="删除" @click="delRC(item.id)"><i class="del main_menu_del"></i></a><i class="up_icon icon_c"></i>
              </dt>
              <!--此处字数请程序控制不超过7个汉字-->
              <ul class="ul1 total-scope-tan subUL">
                <dd v-for="n in item.nodes" :key="n.id">
                  <a href="javascript:;" @click="searchByClassification(n.id)" class="single_ellipsis subTitle" style="width: 135px" >{{n.name}}</a> <i class="edit" title="编辑" @click="editClassification('s', n.name, n.id, n.parentId, n.parentIds)"></i>
                  <a href="javascript:;" title="删除" @click="delRC(n.id)"><i class="del delSub"></i></a>
                </dd>
                <P>
                </P>
              </ul>
            </span>
      </dl>
    </div>
    <!--/资源管理左侧菜单-->
    <!--资源管理右侧列表-->
    <div class="col_2_2 w797 zy_right">
      <div class="zy_right_title">资源管理中心</div>
      <div class="gj_top_class">
        <input name="" type="button" class="btn_s_gj" @click="searchByFilter()" /><input name="title" type="text" class="put_gj" v-model="filter.title" @keyup.13="searchByFilter()"/>
        <select name="isPublic" class="selcet_put" v-model="filter.state" @change="searchByFilter()">
          <option value="">全部(上下架)</option>
          <option v-for='item in Dropdown.state.putOnOffType1' :key="item.value" :value="item.value">{{item.label}}</option>
        </select>
        <select name="type" class="selcet_put" v-model="filter.type" @change="searchByFilter()">
          <option value="">全部(资源类型)</option>
          <option v-for='item in Dropdown.state.resourceType' :key="item.value" :value="item.value">{{item.label}}</option>
        </select>
        <a class="btn btn_add" @click="editResource('')">新增资源</a>
      </div>
      <div class="zy_list" style="min-height:670px;">
        <dl v-for="item in list" :key="item.id">
          <dt>
            <div v-if="item.isReview=='1'">
              <p class="shz">审核中</p>
              <a href="javascript:void(0);"><img src="@/assets/images/zy_list_3@2x.png"/></a>
            </div>
            <div v-if="item.state=='1' && item.isReview=='2'" @click="editResource(item.id)">
              <p class="stop">停</p>
              <!--<a href="javascript:void(0);"  @click="$utils.fadeIn('.biaoqian_btn')" >标签</a>-->
              <p class="kz_icon"><a href="javascript:void(0);"  @click="putOnOff('on', item.id, $event)" >上架</a>|<a href="javascript:;" @click="viewResource(item.id, item.type, $event, item.tranceStatus)">预览</a>|<a href="javascript:void(0);">标签</a></p>
              <a href="javascript:void(0);">
                <img v-if="item.cover" :src="item.cover"/>
                <img v-if="!item.cover" src="@/assets/images/zy_list_3@2x.png"/>
              </a>
            </div>
            <div v-if="item.state=='0' && item.isReview=='2'" @click="editResource(item.id)">
              <!--<i class='input_style checkbox_bg'><input type="checkbox" value="1" class="inputCheck"></i>-->
              <p class="kz_icon"><a href="javascript:void(0);"  @click="putOnOff('off', item.id, $event)" >下架</a>|<a href="javascript:;" @click="viewResource(item.id, item.type, $event, item.tranceStatus)">预览</a>|<a href="javascript:void(0);">标签</a></p>
              <a href="javascript:void(0);">
                <img v-if="item.cover" :src="item.cover"/>
                <img v-if="!item.cover" src="@/assets/images/zy_list_3@2x.png"/>
              </a>
            </div>
          </dt>
          <dd>
            <p>{{item.title}}</p>
            <p class="author">{{item.createName}}</p>
            <p class="update">{{item.updateTime}}</p>
          </dd>
        </dl>
        <h5 class="none_ts" v-if="resourceCnt <= 0">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
      </div>
      <div class="zy_list_bottom">
        <dl>
          <dt><!--<input id="sel_1" type="checkbox" v-model="allCheck" style="opacity: 1;" /> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/>--> <!--<input name="" type="button" value="删除所选"  class="btn_zy_bottom" />--> 共{{resourceCnt}}个资源</dt>
          <dd v-if="resourceCnt > 0">
            <paginate ref="paginate" :click-handler="clickCallback" :page-count=pages
                      :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                      :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                      :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                      :first-last-button=$global.paginationOptions.first_last_button
                      :active-class=$global.paginationOptions.active_class
                      :disabled-class=$global.paginationOptions.disabled_class
                      :first-button-text=$global.paginationOptions.first_button_text
                      :last-button-text=$global.paginationOptions.last_button_text
                      :prev-text=$global.paginationOptions.prev_text
                      :next-text=$global.paginationOptions.next_text>
            </paginate>
          </dd>
        </dl>
      </div>
    </div>
    <!--/资源管理右侧列表-->

    <!--添加大类弹出-->
    <div class="tan add_b_menu" style="display:none;">
      <div class="add_con">
        <dl>
          <dt><input name="" type="text"  v-model="name_f" placeholder="请输入大类名称"/></dt>
          <!--<dt style="height:35px;"><input name="" type="text"  v-model="name_f_sort" placeholder="请输入排序"/></dt>-->
          <dd><input name="" type="button" value="取消" @click="$utils.fadeOut('.add_b_menu')" />　　<input type="button" value="确定" class="red_color" @click="submitClassification(name_f, name_f_sort)" /></dd>
        </dl>
      </div>
    </div>
    <!--/添加大类弹出-->
    <!--添加子类弹出-->
    <div class="tan add_s_menu" style="display:none;">
      <div class="add_con">
        <dl>
          <dt><input name="" type="text"  v-model="name_s" placeholder="请输入子类名称"/></dt>
          <!--<dt><input name="" type="text"  v-model="name_s_sort" placeholder="请输入排序"/></dt>-->
          <dd><input name="" type="button" value="取消" @click="$utils.fadeOut('.add_s_menu')" />　　<input type="button" value="确定" class="red_color" @click="submitClassification(name_s, name_s_sort)" /></dd>
        </dl>
      </div>
    </div>
    <!--/添加子类弹出-->
    <!--停用弹出-->
    <div class="tan stop_btn" style="display:none;">
      <div class="add_con">
        <dl>
          <dt>您确定下架该资源吗？</dt>
          <dd><input name="" type="button" value="取消" @click="$utils.fadeOut('.stop_btn')" />　　<input name="" type="button" value="确定" class="red_color" @click="submitPutOnOff('4', putOnOffArr)" /></dd>
        </dl>
      </div>
    </div>
    <!--/停用弹出-->
    <!--启用弹出-->
    <div class="tan open_btn" style="display:none;">
      <div class="add_con">
        <dl>
          <dt>您确定需要启用吗？</dt>
          <dd><input name="" type="button" value="取消" @click="$utils.fadeOut('.open_btn')" />　　<input name="" type="button" value="确定" class="red_color" @click="submitPutOnOff('5', putOnOffArr)" /></dd>
        </dl>
      </div>
    </div>
    <!--/启用弹出-->
    <!--资源预览弹出-->
    <div class="tan resourcePreview" style="display:none;">
      <div class="px_add_con rp_add_con" style="height:520px;">
        <div class="h370 rdiv" style="height:550px;">
          <h3>资源预览</h3>
          <a  href="javascript:void(0);"  class="close" @click="closeViewModal()" ></a>
          <div class="h200" style="overflow-x:hidden;height:480px;">
            <div  class="video_con" style="padding-top:10px;height:420px;">
              <!--视频-->
              <video-player  class="video-player-box"
                             ref="videoPlayer"
                             :options="playerOptions"
                             :playsinline="true"
                             customEventName="customstatechangedeventname">
              </video-player>
              <!--/视频-->
              <!--<div class="video_bottom">
                <dl>
                  <dt>
                    <p>共{{(resourceInfo.length/60).toFixed(2)}}分钟</p>
                  </dt>
                  <dd>
                    <p>上传时间：{{resourceInfo.createTime}} &#45;&#45; 上传者：{{resourceInfo.createName}}</p>
                    &lt;!&ndash;<p>文件大小：400M</p>&ndash;&gt;
                  </dd>
                </dl>
              </div>-->
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <!--<div class="w240 wrap" style="text-align: center">
          <input name="" type="button" value="确定" class="all_btn" @click="closeViewModal()" />
        </div>-->
      </div>
    </div>
    <!--/资源预览弹出-->
    <!--标签弹出-->
    <!--<div class="tan biaoqian_btn" style="display:none;">
      <div class="biaoqian_con">
        <dl id='tan_biaoqian_panel'>
          <dt ><i>已选标签</i><i>已选标签</i><i>已选标签</i><i>已选标签</i><i>已选标签</i></dt>
          <dd>
            <p>标签选择</p>
            <p><i>标签文字1</i><i>标签文字4</i><i>标签文字6</i><i>标签文字7</i><i>标签文字8</i></p>
          </dd>
        </dl>
        <ul><input name="" type="button" value="取消" @click="$utils.fadeOut('.biaoqian_btn')" />　　<input name="" type="button" value="确定" class="red_color" @click="$utils.fadeOut('.biaoqian_btn')" /></ul>
      </div>
    </div>-->
    <!--/标签弹出-->
  </div>
</template>
<script>

import Dropdown from '@/store/modules/dropdowns'
import {init} from '@/assets/js/public'
import Paginate from 'vuejs-paginate'
import router from '@/router'
import Bus from '@/utils/bus'
import { mapState, mapActions } from 'vuex'
import s_query from '@/utils/s_query'
import { getCookie } from '@/store/cookies'
// require styles
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
export default {
  components: { Paginate, videoPlayer },
  data () {
    return {
      Dropdown: Dropdown,
      filter: {
        pageNo: 1,
        pageSize: 15,
        type: "",
        state: ""
      },
      list: [],
      RCTree: [],
      allCheck: '',
      pages: 0,
      resourceCnt: 0,

      name_f: '',
      name_s: '',
      name_f_sort: '0',
      name_s_sort: '0',

      classification: {},
      resourceInfo: {},
      putOnOffArr: [],
      prefix: this.$route.meta.prefix || '',
      playerOptions: {
        // videojs options
        muted: true,
        width: 640,
        height: 400,
        language: 'en',
        playbackRates: [1.0],
        sources: [{
          type: "video/mp4",
          src: "http://vod.bylonline.cn/9fc0cb5a737f4e08b93b3d360340dfff/a09f29b95fbd4249b74e7073dbf537e6-734884e784050aa4f71eae0abec3e9cb-ld.mp4"
        }],
        poster: ""
      }
    }
  },
  created () {
    if (getCookie('query_record') && getCookie('query_record')[this.$route.path]) {
      this.filter = getCookie('query_record')[this.$route.path]
    }
    this.getResourceClassification()
    this.getResources(this.filter)
  },
  mounted () {
    this.$nextTick(() => {
      init()
    })
    Bus.$on('initData_/org/resourceList', (data) => { // 点击菜单“资源管理”重置数据
      this.filter =  {
        pageNo: 1,
        pageSize: 15,
        type: "",
        state: ""
      }
      this.getResources(this.filter)
    })
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    clickCallback (pageNum) {
      this.filter.pageNo = pageNum
      this.getResources(this.filter)
    },
    resetPagination () {
      this.filter.pageNo = 1
      if (this.$refs.paginate) {
        this.$refs.paginate.selected = 0 // 重置 active-class为第一页
      }
    },
    // 编辑大分类
    editClassification (type, name, id, parentId, parentIds) {
      if (type == 'f' && name == null) {
        this.$utils.fadeIn('.add_b_menu')
        this.name_f = ''
        // this.name_f_sort = ''
      } else if (type == 's' && name == null) {
        this.$utils.fadeIn('.add_s_menu')
        this.name_s = ''
        parentIds = parentIds + ','+parentId
        // this.name_s_sort = ''
      } else if (type == 'f' && name != null) {
        this.$utils.fadeIn('.add_b_menu')
        this.name_f = name
        // this.name_f_sort = sort
      } else if (type == 's' && name != null) {
        this.$utils.fadeIn('.add_s_menu')
        this.name_s = name
        // this.name_s_sort = sort
      }
      this.classification = {
        id: id,
        name: name,
        parentId: parentId,
        parentIds: parentIds
        // sort: sort
      }
    },
    submitClassification (name, sort) {
      if (name && name != '') {
        this.classification.name = name
        this.classification.sort = sort
        this.$api.post(this.$global.resourceApiPath, '/resource/classification/edit', this.classification, r => {
          this.$utils.fadeOut('.add_b_menu')
          this.$utils.fadeOut('.add_s_menu')
          this.classification = {}
          this.getResourceClassification()
        })
      }
    },
    searchByClassification (id) {
      this.filter = {
        pageNo: 1,
        pageSize: 15,
        classificationId: id,
        type: "",
        state: ""
      }
      this.resetPagination()
      this.getResources(this.filter)
    },
    searchByFilter () {
      this.filter.classificationId = '' // reset
      this.resetPagination()
      this.getResources(this.filter)
    },
    getResources (filter) {
      s_query.save(this.$route.path, filter)
      this.$api.post(this.$global.resourceApiPath, '/resource/resources', filter, r => {
        if (r.cntData) {
          this.resourceCnt = r.cntData
        } else {
          this.resourceCnt = 0
        }
        this.pages = Math.ceil(r.cntData / this.filter.pageSize)
        this.list = r.data
        this.$nextTick(() => { // 数据初始化时分页组件需要手动更新
          if (this.$refs.paginate) {
            this.$refs.paginate.selected = this.filter.pageNo - 1
          }
        })
      })
    },
    editResource (id) {
      if (id == '') {
        id = 'create'
      }
      this.$router.push({path: this.prefix + '/org/resource/'+ id})
    },
    delRC (id) {
      this.$api.getRestful(this.$global.resourceApiPath, '/resource/classification/delete/' + id, {}, r => {
        this.getResourceClassification()
      })
    },
    getResourceClassification () {
      this.$api.post(this.$global.resourceApiPath, '/resource/classification/list', {}, r => {
        let tree = r
        this.RCTree = tree.data
      })
    },
    putOnOff (type, id, e) {
      e.stopPropagation();
      this.putOnOffArr = []
      var action
      if (type == 'on') {
        action = '5'
        this.$utils.fadeIn('.open_btn')
      } else if (type == 'off') {
        action = '4'
        this.$utils.fadeIn('.stop_btn')
      }
      this.putOnOffArr.push(id)
    },
    submitPutOnOff (action, idArr) {
      var idStr = ''
      for (var i = 0; i<idArr.length; i++) {
        if (i < idArr.length -1) {
          idStr += idArr[i] + ','
        } else if (i == idArr.length -1) {
          idStr += idArr[i]
        }
      }
      this.$api.get(this.$global.resourceApiPath, '/resource/action/batch', {action: action, ids: idStr}, r => {
        if (action == '4') {
          this.$utils.fadeOut('.stop_btn')
        } else if (action == '5') {
          this.$utils.fadeOut('.open_btn')
        }
        this.getResources(this.filter)
      })
    },
    viewResource (id, type, e, tranceStatus) {
      e.stopPropagation();
      this.$api.get(this.$global.resourceApiPath, '/resource/view/' + id, {}, r => {
        this.resourceInfo = r.data
        if (this.resourceInfo.tranceStatus == '1') {
          if (type=='2') {
            this.$refs.videoPlayer.player.src(this.resourceInfo.filePathMp4)
            this.$utils.fadeIn('.resourcePreview')
          } else {
            window.open(this.resourceInfo.filePathMp4, '_black')
          }
        } else {
          let msg = (tranceStatus == '0') ? '视频未转码' : '视频转码失败'
          this.$toasted.show(msg)
        }
      })
    },

    closeViewModal () {
      this.$utils.fadeOut('.resourcePreview')
      this.$refs.videoPlayer.player.pause()
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/resource/list.vue